import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Form, Input, Card, Select, Row, Col, Spin } from "antd";
import { makeField } from "components/Common/Controls/MakeField";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { userManagementActions } from "./ducks";
import { allCountriesJson } from "../../../DummyData/AllCountry";
import {
  FormItemLayout,
  FormItemLayout2,
  TailFormItemLayout,
} from "../../../constants/Utilities";

const FormItem = Form.Item;
const Option = Select.Option;

const AInputField = makeField(Input);
const ASelectField = makeField(Select);

class SellerDetailsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerDetails: null,
      mode: null,
      type: null,
      isDisabled: true,
      isCreate: false,
    };
  }

  componentDidMount() {
    const { params } = this.props.match;
    const mode = params && params.mode;
    const type = params && params.type;
    const id = params && params.id;
    if (mode !== "create") {
      this.props.userManagementActions.getUser({ user_id: id });
    }
    const isDisabled = mode === "edit" || mode === "create" ? false : true;
    const isCreate = mode === "create" ? true : false;
    this.setState({
      mode,
      type,
      isDisabled,
      isCreate,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { getUser } = this.props;
    if (
      getUser &&
      getUser.data &&
      getUser.data.data &&
      JSON.stringify(getUser) !== JSON.stringify(prevState.getUser)
    ) {
      var receivedObj = {
        displayname: getUser.data.data.name,
        email: getUser.data.data.email,
        phonenumber: getUser.data.data.phone,

        legalName: getUser.data.data.legal_name,
        seller_category: getUser.data.data.seller_category,
        address1: getUser.data.data.address1,
        address2: getUser.data.data.address2,
        city: getUser.data.data.city,
        state: getUser.data.data.state,
        country: getUser.data.data.country,
        postcode: getUser.data.data.zip,
      };

      this.props.initialize(receivedObj);
      this.setState({
        getUser: getUser,
      });
    }
  }

  componentWillUnmount() {
    this.props.userManagementActions.clearUser();
  }

  handleSubmit = (values) => {
    const { userManagementActions } = this.props;
    const { isCreate } = this.state;
    const { params } = this.props.match;
    const id = params && params.id;
    const type = params && params.type;

    var userDto = {
      store_name: values.displayname,
      legal_name: values.legalName,
      seller_category: values.seller_category,
      phone: values.phonenumber,
      role: "Seller",
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      country_code: values.country,
      zip_code: values.postcode,
    };

    var createUserDto = {
      store_name: values.displayname,
      email: values.email,
      legal_name: values.legalName,
      seller_category: values.seller_category,
      phone: values.phonenumber,
      role: "Seller",
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      country_code: values.country,
      zip_code: values.postcode,
    };

    if (isCreate) {
      userManagementActions.createUser({
        userDto: createUserDto,
        type: type,
        form: "SellerDetailsForm",
      });
    } else {
      userManagementActions.updateUser({
        id: id,
        userDto: userDto,
        type: type,
        form: "SellerDetailsForm",
      });
    }
  };

  editHandler = () => {
    const { params } = this.props.match;
    const type = params && params.type;
    const id = params && params.id;
    this.setState({
      mode: "edit",
      isDisabled: false,
    });
    this.props.history.push(
      `/seller/dashboard/userManagement/${type}/details/edit/${id}`
    );
  };
  render() {
    const { handleSubmit, getUser } = this.props;
    const { isDisabled, isCreate } = this.state;

    return (
      <Spin spinning={getUser.pending}>
        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <Card className="gx-card" title="Seller Information">
            <FormItem {...FormItemLayout} label="Display Name / Shop Name">
              <Field
                formItemLayout={FormItemLayout2}
                name="displayname"
                component={AInputField}
                placeholder="Display Name / Shop Name"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="email address">
              <Field
                formItemLayout={FormItemLayout2}
                name="email"
                component={AInputField}
                placeholder="email address"
                hasFeedback
                disabled={!isCreate}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="Phone Number">
              <Field
                formItemLayout={FormItemLayout2}
                name="phonenumber"
                component={AInputField}
                placeholder="Phone Number"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>
          </Card>

          <Card className="gx-card" title="Business Information">
            <FormItem {...FormItemLayout} label="Legal Name / Business Owner">
              <Field
                formItemLayout={FormItemLayout2}
                name="legalName"
                component={AInputField}
                placeholder="Legal Name / Business Owner"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="Seller Category">
              <Field
                formItemLayout={FormItemLayout2}
                name="seller_category"
                component={ASelectField}
                hasFeedback
                disabled={isDisabled}
              >
                <Option value="Individual">Individual</Option>
                <Option value="SME">SME</Option>
                <Option value="Producer">Producer</Option>
                <Option value="Manufacturer">Manufacturer</Option>
                <Option value="Trading Business">Trading Business</Option>
              </Field>
            </FormItem>

            <FormItem {...FormItemLayout} label="Address 1">
              <Field
                formItemLayout={FormItemLayout2}
                // label="First Name"
                name="address1"
                component={AInputField}
                placeholder="Address 1"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="Address 2">
              <Field
                formItemLayout={FormItemLayout2}
                // label="First Name"
                name="address2"
                component={AInputField}
                placeholder="Address 2"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="City / Town">
              <Field
                formItemLayout={FormItemLayout2}
                // label="First Name"
                name="city"
                component={AInputField}
                placeholder="City / Town"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="State">
              <Field
                formItemLayout={FormItemLayout2}
                // label="First Name"
                name="state"
                component={AInputField}
                placeholder="State"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>

            <FormItem {...FormItemLayout} label="Country / Region">
              <Field
                formItemLayout={FormItemLayout2}
                name="country"
                component={ASelectField}
                hasFeedback
                disabled={isDisabled}
              >
                {allCountriesJson.map((country, i) => {
                  return (
                    <Option key={i} value={country.alpha_3}>
                      {country.name}
                    </Option>
                  );
                })}
              </Field>
            </FormItem>

            <FormItem {...FormItemLayout} label="Postcode">
              <Field
                formItemLayout={FormItemLayout2}
                // label="First Name"
                name="postcode"
                component={AInputField}
                placeholder="Postcode"
                hasFeedback
                disabled={isDisabled}
              />
            </FormItem>
            <hr></hr>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="mb-0 float-right">
                  <FormItem
                    {...TailFormItemLayout}
                    style={{ marginBottom: "0" }}
                  >
                    {/* {isDisabled ? (
                      <Button
                        disabled={userRole === "Moderator"}
                        type="primary"
                        onClick={() => this.editHandler()}
                        style={{
                          marginRight: "10px",
                          marginBottom: "0",
                          width: "120px",
                        }}
                      >
                        Edit
                      </Button>
                    ) : null} */}
                    {/* {!isDisabled ? (
                      <Button
                        disabled={userRole === "Moderator"}
                        type="primary"
                        htmlType="submit"
                        style={{
                          marginRight: "10px",
                          marginBottom: "0",
                          width: "120px",
                        }}
                      >
                        Submit
                      </Button>
                    ) : null} */}
                  </FormItem>
                </div>
              </Col>
            </Row>
          </Card>
        </Form>
      </Spin>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.displayname) {
    errors.displayname = "Display Name / Shop Name is required";
  }
  if (!values.email) {
    errors.email = "Email Address is required";
  }
  if (!values.phonenumber) {
    errors.phonenumber = "Phone Number is required";
  }

  if (!values.legalName) {
    errors.legalName = "Legal Name / Business Owner is required";
  }
  if (!values.seller_category) {
    errors.seller_category = "Seller category is required";
  }
  // if (!values.legalform) {
  //   errors.lealform = "Legal Form is required";
  // }
  if (!values.address1) {
    errors.address1 = "Address line 1 is required";
  }
  if (!values.city) {
    errors.city = "City / Town is required";
  }
  if (!values.country) {
    errors.country = "Country is required";
  }
  if (!values.state) {
    errors.state = "Seller state is required";
  }
  // if (!values.region) {
  //   errors.region = "Seller Region is required";
  // }
  if (!values.postcode) {
    errors.postcode = "Seller Postcode is required";
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    getUser: state.UserManagement.getUser,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    userManagementActions: bindActionCreators(userManagementActions, dispatch),
  };
}

export default withRouter(
  reduxForm({
    form: "SellerDetailsForm",
    validate,
  })(connect(mapStateToProps, mapDispatchToProps)(SellerDetailsForm))
);
